var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeStartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99914 4.29932C6.9518 4.29932 5.28613 5.96498 5.28613 8.01232C5.28613 10.0597 6.9518 11.7253 8.99914 11.7253C11.0465 11.7253 12.7121 10.0597 12.7121 8.01232C12.7121 5.96498 11.0465 4.29932 8.99914 4.29932ZM8.99914 10.162C7.81383 10.162 6.84949 9.19764 6.84949 8.01232C6.84949 6.82701 7.81383 5.86268 8.99914 5.86268C10.1845 5.86268 11.1488 6.82701 11.1488 8.01232C11.1488 9.19764 10.1845 10.162 8.99914 10.162Z",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99961 0C4.5816 0 0.987305 3.59434 0.987305 8.01231V8.23379C0.987305 10.4682 2.26832 13.0719 4.79488 15.9726C6.62645 18.0754 8.43242 19.5416 8.50836 19.603L8.99961 20L9.49086 19.6031C9.56684 19.5417 11.3728 18.0754 13.2043 15.9726C15.7309 13.0719 17.0119 10.4682 17.0119 8.23383V8.01234C17.0119 3.59434 13.4176 0 8.99961 0ZM15.4486 8.23383C15.4486 12.0098 10.5833 16.5807 8.99961 17.9683C7.41551 16.5803 2.55066 12.0095 2.55066 8.23383V8.01234C2.55066 4.45641 5.44367 1.5634 8.99961 1.5634C12.5555 1.5634 15.4486 4.45641 15.4486 8.01234V8.23383Z",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeStartIcon);
export default __webpack_public_path__ + "static/media/intake-start-icon.55853827391fcb816c9c138cfa7d8bd9.svg";
export { ForwardRef as ReactComponent };